import { schedulingApi } from "./generated/scheduling";


export const scheduling = schedulingApi.enhanceEndpoints({
  endpoints: {
    appSchedulingCalendarEventsList: (endpoint) => {
      endpoint.onQueryStarted = async (arg, { dispatch, queryFulfilled }) => {
        try {
          // Wait for the query to complete
          const { data } = await queryFulfilled;
          
          // If we have data and it contains events, update individual caches
          if (data?.data && Array.isArray(data.data)) {
            data.data.forEach((event) => {
              // Update the individual event cache using the event ID as the lookup key
              if (event.lookup_key) {
                dispatch(
                  scheduling.util.upsertQueryData('appSchedulingCalendarEventsRetrieve', event.lookup_key, event)
                );
              }
            });
          }
        } catch (error) {
          // Query failed, no need to update individual caches
          console.warn('List query failed, skipping individual cache updates:', error);
        }
      };
    },
    // Also enhance the retrieve endpoint to provide specific tags for better invalidation
    appSchedulingCalendarEventsRetrieve: (endpoint) => {
      endpoint.providesTags = (result, error, arg) => [
        { type: 'CalendarEvent', id: arg }
      ];
    }
  }
});

